export const SYNC_ABSENCE_THRESHOLD_MS = 30_000; // tab hidden longer than this triggers sync
export const SYNC_QUEUE_THRESHOLD = 5; // pendingQueue length above this triggers sync
export const SYNC_DELTA_THRESHOLD_MS = 30_000; // (toTs - fromTs) above this triggers sync
export const SYNC_DISTANCE_THRESHOLD_M = 50; // skip sync if movement is below this
export const SYNC_ANIMATION_DURATION_MS = 1000; // fixed marker animation length
// Gap entre timestamps GPS de posiciones live consecutivas que dispara sync
// (el marcador viaja directo al destino, sin dibujar línea, y el trail se
// colapsa) en vez de dibujar el tramo como segmento del trail. Más alto que
// SYNC_DELTA_THRESHOLD_MS a propósito: cortes breves de reporte en conducción
// normal (<2 min) siguen dibujando línea.
export const SYNC_LIVE_GAP_THRESHOLD_MS = 120_000;
